export default function safeStringify(obj = {}) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return; // Circular reference found, skip it
      }
      seen.add(value);
    }
    return value;
  });
}
